import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const WideContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => `${theme.grid.gutter / 2}px`};
  padding-right: ${({ theme }) => `${theme.grid.gutter / 2}px`};
  width: 100%;

  ${({
    theme: {
      grid: { containerWideScreenMaxWidths },
    },
  }) =>
    Object.keys(containerWideScreenMaxWidths).map((key) => {
      return css`
        ${breakpoint(key)`
          max-width: ${containerWideScreenMaxWidths[key]};
        `}
      `;
    })}
`;

export default WideContainer;
